import { ensureValidDate } from '@opallabs/lambda'
import type { IANATimezoneIdentifier, UTCOffsetTuple } from './types'
import { utcOffsetForZoneAsTuple } from './utcOffsetForZone'

/**
 * Compute the difference between the user’s current time zone and the
 * `timezoneIdentifier` time zone on the given `date`. Returns a tuple of hours
 * (positive or negative) and minutes.
 *
 * If the hour is positive, `timezoneIdentifier` is ahead of the user’s current
 * time zone. If the hour is negative, `timezoneIdentifier` is behind the
 * user’s current time zone.
 *
 * @note This returns a tuple, rather than a number, so that calling code can
 *   choose to format the offset in a custom way--for example, using
 *   `date-fns`’ `formatDuration`.
 */
export function offsetFromUserTimeZone(
  date: Date,
  timezoneIdentifier: IANATimezoneIdentifier
): UTCOffsetTuple {
  ensureValidDate(date)

  const targetOffset = utcOffsetForZoneAsTuple(date, timezoneIdentifier)

  const userZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const userOffset = utcOffsetForZoneAsTuple(date, userZone)

  return [targetOffset[0] - userOffset[0], targetOffset[1] - userOffset[1]]
}
